import axios, { AxiosResponse } from 'axios'
import IMotorista from 'modules/motorista/domain/entities/IMotorista'
import IBaixarComprovanteExtratoRequest from 'modules/pagamentos/domain/entities/IBaixarComprovanteExtratoRequest'
import { IBaixarPdfBoletoDepositoRequest } from 'modules/pagamentos/domain/entities/IBaixarPdfBoletoDepositoRequest'
import { IBoletoDepositoResponse } from 'modules/pagamentos/domain/entities/IBoletoDepositoResponse'
import IComprovantesExtratoRequest from 'modules/pagamentos/domain/entities/IComprovantesExtratoRequest'
import IComprovantesExtratoResponse from 'modules/pagamentos/domain/entities/IComprovantesExtratoResponse'
import IConsultaCartoesResponseDTO from 'modules/pagamentos/domain/entities/IConsultaCartoesResponseDTO'
import IContaEscrow from 'modules/pagamentos/domain/entities/IContaEscrow'
import { IExportarExtratoRequest } from 'modules/pagamentos/domain/entities/IExportarExtratoRequest'
import { IExportarExtratoResponse } from 'modules/pagamentos/domain/entities/IExportarExtratoResponse'
import IFindAllExtratoRequest from 'modules/pagamentos/domain/entities/IFindAllExtratoRequest'
import IFindAllExtratoResponse from 'modules/pagamentos/domain/entities/IFindAllExtratoResponse'
import IFindFavorecidosContaBancariaResponse from 'modules/pagamentos/domain/entities/IFindFavorecidosContaBancariaResponse'
import IFindFavorecidosTmovPayRequest from 'modules/pagamentos/domain/entities/IFindFavorecidosTmovPayRequest'
import IGerarBoletoDepositoRequest from 'modules/pagamentos/domain/entities/IGerarBoletoDepositoRequest'
import ITransferenciaContaBancariaRequestDTO from 'modules/pagamentos/domain/entities/ITransferenciaContaBancariaRequestDTO'
import ITransferenciaContaBancariaResponseDTO from 'modules/pagamentos/domain/entities/ITransferenciaContaBancariaResponse'
import ITransferenciaTmovPayRequestDTO from 'modules/pagamentos/domain/entities/ITransferenciaTmovPayRequestDTO'
import ITransferenciaTmovPayResponseDTO from 'modules/pagamentos/domain/entities/ITransferenciaTmovPayResponse'
import IVerifyPasswordRequestDTO from 'modules/pagamentos/domain/entities/IVerifyPasswordRequestDTO'
import { IPagamentoRepository } from 'modules/pagamentos/domain/repositories/IPagamentoRepository'
import { ServiceConfig } from 'shared/services/ServiceConfig'
import Formatter from 'shared/utils/formatters'

import IPercentualTransferenciaMotorista from '../../domain/entities/IPercentualTransferenciaMotorista'
import IUseNewHomeResponseDTO from '../../domain/entities/IUseNewHomeResponseDTO'
import { IPagamentoBoletoResponse } from '../../domain/entities/IPagamentoBoletoResponse'
import { parseISO } from 'date-fns'
import { IPagarBoletoRequestDTO } from '../../domain/entities/IPagarBoletoRequestDTO'
import { IPagarBoletoResponseDTO } from '../../domain/entities/IPagarBoletoResponseDTO'
import IAceitarTermosOnboardingRequest from 'modules/pagamentos/domain/entities/IAceitarTermosOnboardingRequest'
import IConfirmarEnvioDocumentosOnboardingRequest from 'modules/pagamentos/domain/entities/IConfirmarEnvioDocumentosOnboardingRequest'
import { ICreateContaPJOnboardingRequest } from 'modules/pagamentos/domain/entities/ICreateContaPJOnboardingRequest'
import IEnviarDocumentoOnboardingRequest from 'modules/pagamentos/domain/entities/IEnviarDocumentoOnboardingRequest'
import ITermosAceiteOnboardingResponse from 'modules/pagamentos/domain/entities/ITermosAceiteOnboardingResponse'
import IEnviarPinRequestDTO from 'modules/pagamentos/domain/entities/IEnviarPinRequestDTO'
import IEnviarPinResponseDTO from 'modules/pagamentos/domain/entities/IEnviarPinResponseDTO'
import IValidarPinRequestDTO from 'modules/pagamentos/domain/entities/IValidarPinRequestDTO'
import ITermosAceiteOnboardingRequest from 'modules/pagamentos/domain/entities/ITermosAceiteOnboardingRequest'
import IContaPagamentoContraCteResponseDTO from '../../domain/entities/IContaPagamentoContraCteResponseDTO'
const http = new ServiceConfig()
export default class PagamentoRepository implements IPagamentoRepository {
  async findFavorecidosContaBancaria(
    frotistaId: number,
  ): Promise<IFindFavorecidosContaBancariaResponse[]> {
    const url = '/contas/bancarias'
    const result: AxiosResponse<IFindFavorecidosContaBancariaResponse[]> =
      await http.get(url, {
        params: {
          frotista_id: frotistaId,
        },
      })
    return result.data
  }

  async findFavorecidosTmovPay(
    params: IFindFavorecidosTmovPayRequest,
  ): Promise<IMotorista[]> {
    let url = `/contas/tmov-pay?frotista_id=${params.frotistaId}&listar_conta_pagamento_contra_cte=true&`
    if (params.filtro) {
      const filtro = params.filtro.replace(
        Formatter.caracteresNaoNumericosNemLetras(),
        '',
      )
      if (parseInt(filtro)) url = url + `cpf=${filtro}`
      else url = url + `nome=${params.filtro}`
    }

    const result: AxiosResponse<IMotorista[]> = await http.get(url)
    return result.data
  }

  async get(frotistaId: number): Promise<IPercentualTransferenciaMotorista> {
    const response: AxiosResponse<IPercentualTransferenciaMotorista> =
      await http.get('/percentuais-transferencias', {
        params: {
          frotista_id: frotistaId,
        },
      })
    return response.data
  }

  async update(data: IPercentualTransferenciaMotorista): Promise<void> {
    await http.put('/percentuais-transferencias', data)
  }

  async find({
    data_fim,
    data_inicio,
    frotista_id,
  }: IFindAllExtratoRequest): Promise<IFindAllExtratoResponse> {
    const result: AxiosResponse<IFindAllExtratoResponse> = await http.get(
      '/pagamentos/extrato',
      {
        params: {
          data_fim: data_fim.toISOString(),
          data_inicio: data_inicio.toISOString(),
          frotista_id,
        },
      },
    )

    return result.data
  }

  async transferToTmovPay(
    data: ITransferenciaTmovPayRequestDTO,
  ): Promise<ITransferenciaTmovPayResponseDTO> {
    const result = await http.post('/contas/transfer/tmov-pay', data)
    return result.data as ITransferenciaTmovPayResponseDTO
  }

  async transferToBankAccount(
    data: ITransferenciaContaBancariaRequestDTO,
  ): Promise<ITransferenciaContaBancariaResponseDTO> {
    const result = await http.post('/contas/transfer/bank-account', data)
    return result.data as ITransferenciaContaBancariaResponseDTO
  }

  async getCartoes(frotistaId: number): Promise<IConsultaCartoesResponseDTO> {
    const result = await http.get('/cartoes', {
      params: {
        frotista_id: frotistaId,
      },
    })
    return result.data as IConsultaCartoesResponseDTO
  }

  async verifyPassword({
    password,
    frotistaId,
  }: IVerifyPasswordRequestDTO): Promise<void> {
    await http.get('/validates/pagamentos/cartao', {
      params: {
        frotista_id: frotistaId,
      },
      headers: {
        password: password,
      },
    })
  }

  async exportarExtrato({
    data_fim,
    data_inicio,
    frotista_id,
  }: IExportarExtratoRequest): Promise<IExportarExtratoResponse> {
    const result: AxiosResponse<IExportarExtratoResponse> = await http.get(
      '/pagamentos/extrato/exportar',
      {
        params: {
          data_fim: data_fim.toISOString(),
          data_inicio: data_inicio.toISOString(),
          frotista_id,
        },
      },
    )

    return result.data
  }

  async gerarBoletoDeposito(
    data: IGerarBoletoDepositoRequest,
  ): Promise<IBoletoDepositoResponse> {
    const result: AxiosResponse<IBoletoDepositoResponse> = await http.post(
      '/boletos/deposito',
      data,
    )

    return result.data
  }

  async listaBoletosDeposito(
    frotistaId: number,
  ): Promise<IBoletoDepositoResponse[]> {
    const result: AxiosResponse<IBoletoDepositoResponse[]> = await http.get(
      '/boletos/deposito',
      {
        params: {
          frotista_id: frotistaId,
        },
      },
    )

    return result.data
  }

  async baixarPdfBoletoDeposito({
    codigo_de_barras,
    frotista_id,
    id_unico_dock,
  }: IBaixarPdfBoletoDepositoRequest): Promise<any> {
    const result: AxiosResponse = await http.get(
      '/boletos/deposito/baixar-pdf',
      {
        responseType: 'arraybuffer',
        params: {
          codigo_de_barras,
          frotista_id,
          id_unico_dock,
        },
      },
    )

    return result.data
  }

  async listaContaEscrow(frotistaId: number): Promise<IContaEscrow> {
    const result: AxiosResponse<IContaEscrow> = await http.get(
      '/contas/escrow',
      {
        params: {
          frotista_id: frotistaId,
        },
      },
    )

    return result.data
  }

  async validarUsarNovaHome(): Promise<IUseNewHomeResponseDTO> {
    const result: AxiosResponse<IUseNewHomeResponseDTO> = await http.get(
      '/pagamentos/validar-nova-home',
    )
    return result.data
  }

  async comprovantesExtrato(
    params: IComprovantesExtratoRequest,
  ): Promise<IComprovantesExtratoResponse> {
    const result: AxiosResponse<IComprovantesExtratoResponse> = await http.get(
      '/pagamentos/extrato/comprovantes',
      { params },
    )
    return result.data
  }

  async baixarComprovante(
    params: IBaixarComprovanteExtratoRequest,
  ): Promise<any> {
    const result: AxiosResponse<IComprovantesExtratoResponse> = await http.get(
      '/pagamentos/extrato/comprovantes/baixar',
      {
        responseType: 'blob',
        params,
      },
    )
    return result
  }

  async consultarDadosBoleto(
    codigoBarras: string,
    frotistaId: number,
  ): Promise<IPagamentoBoletoResponse> {
    const result: AxiosResponse<IPagamentoBoletoResponse> = await http.get(
      '/boletos/dados-boleto',
      {
        params: {
          codigo_barras: codigoBarras,
          frotista_id: frotistaId,
        },
      },
    )
    result.data.data_vencimento = parseISO(String(result.data.data_vencimento))
    result.data.data_agendamento = result.data.data_agendamento
      ? parseISO(String(result.data.data_agendamento))
      : undefined
    return result.data
  }

  async pagarBoleto(
    pagamentoRequest: IPagarBoletoRequestDTO,
  ): Promise<IPagarBoletoResponseDTO> {
    const result: AxiosResponse<IPagarBoletoResponseDTO> = await http.post(
      '/boletos/pagar',
      pagamentoRequest,
    )
    return result.data
  }

  async termosAceiteOnboarding(
    params: ITermosAceiteOnboardingRequest,
  ): Promise<ITermosAceiteOnboardingResponse> {
    const result: AxiosResponse<ITermosAceiteOnboardingResponse> =
      await http.get(`onboarding/termos-aceite`, {
        params,
      })
    return result.data
  }

  async aceitarTermosDeUsoOnboarding(
    data: IAceitarTermosOnboardingRequest,
  ): Promise<void> {
    await http.post('/onboarding/termos-aceite', data)
  }

  async enviarDocumentoOnboarding(
    data: IEnviarDocumentoOnboardingRequest,
  ): Promise<void> {
    const formData = new FormData()

    formData.append('arquivo', data.arquivo)
    formData.append('frotista_id', data.frotista_id.toString())
    formData.append('tipo', data.tipo)

    await http.post('/onboarding/documentos', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  async createContaPJOnboarding(
    data: ICreateContaPJOnboardingRequest,
  ): Promise<void> {
    await http.post('/onboarding/conta', data)
  }

  async confirmarEnvioDocumentosOnboarding(
    data: IConfirmarEnvioDocumentosOnboardingRequest,
  ): Promise<void> {
    await http.put('/onboarding/documentos', data)
  }

  async enviarPin(data: IEnviarPinRequestDTO): Promise<IEnviarPinResponseDTO> {
    const result: AxiosResponse<IEnviarPinResponseDTO> = await http.post(
      '/v2/pagamentos/pin/send',
      data,
    )
    return result.data
  }

  async validarPin(data: IValidarPinRequestDTO): Promise<void> {
    await http.post('/v2/pagamentos/pin/verify', data)
  }

  async contaPagamentoContraCte(
    frotista_id: number,
  ): Promise<IContaPagamentoContraCteResponseDTO> {
    const result: AxiosResponse<IContaPagamentoContraCteResponseDTO> =
      await http.get(`/contas/pagamento-contra-cte`, {
        params: {
          frotista_id,
        },
      })
    return result.data
  }
}
